import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function when<T>(condition: T | null | undefined, render: (value: T) => React.ReactNode): React.ReactNode {
  return condition ? render(condition) : null;
}

export function unless<T>(condition: T | null | undefined, render: () => React.ReactNode): React.ReactNode {
  return !condition ? render() : null;
}

// Format Mapbox place address for better readability in Singapore context
export function formatAddress(placeName: string, context?: Array<{ id: string; text: string }>): string {
  // Clean up the place name by removing country and redundant info
  let formattedAddress = placeName;
  
  // Remove problematic patterns specific to Singapore
  formattedAddress = formattedAddress
    .replace(/, Singapore$/, '')
    .replace(/Central Singapore Community Development Council,?\s*/gi, '')
    .replace(/Singapore,?\s*/g, '');
  
  // If we have context, use it to build a cleaner address
  if (context && context.length > 0) {
    const relevantContext = context
      .filter(ctx => 
        !ctx.id.startsWith('country') && 
        !ctx.text.toLowerCase().includes('singapore') &&
        !ctx.text.toLowerCase().includes('community development council')
      )
      .map(ctx => ctx.text);
    
    // Split the main text and context parts
    const parts = formattedAddress.split(',').map(part => part.trim());
    const mainPart = parts[0];
    
    if (mainPart && relevantContext.length > 0) {
      // Combine main part with relevant context, avoiding duplicates
      const contextStr = relevantContext.join(', ');
      if (!mainPart.includes(contextStr) && !contextStr.includes(mainPart)) {
        formattedAddress = `${mainPart}, ${contextStr}`;
      } else {
        formattedAddress = mainPart;
      }
    } else if (mainPart) {
      formattedAddress = mainPart;
    }
  }
  
  return formattedAddress.trim();
}
